import * as React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import { WelcomeTextCard } from "./WelcomeTextCard";
import { InfoCard } from "./InfoCard";
import { PieChartCard } from "./PieChartCard";
import { LineGraphCard } from "./LineGraph";
import { DataTableCard } from "./DataTableCard";
import { BarChartCard } from "./BarChartCard";
import { DataGridCard } from "./DataGridCard";
import { LineGraph2Card } from "./LineGraph2";
import { useTheme, useMediaQuery } from "@mui/material";
import { IconInfoCard } from "../ExtraComponents/IconInfoCard";
import { ChatBubbleOutline, EuroOutlined, PersonOutlined, ShoppingBagOutlined } from "@mui/icons-material";

// const Item = styled(Paper)(({ theme }) => ({
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: "center",
//   color: theme.palette.text.secondary,
// }));

const AppBody = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("lg"));
const theme = useTheme();



  return (
    <Box
      sx={{
        bgcolor: "background.secondary",
        // width: "100vw",

        width: isSmallScreen ? "100vw" : "100%",
      }}
      p={{
        xs: 2,
        md: 4,
      }}
    >
      {/*  Row 1 grid */}
      <Grid
        xs={{ display: "flex" }}
        container
        spacing={{
          xs: 2,
          md: 4,
        }}
      >
        {/* left side of first row grid */}

        <Grid item lg={5} xs={12}>
          <Grid item xs={12}>
            <WelcomeTextCard />
          </Grid>

          <Box mt={3} sx={{ display: "flex" }}>
            <Grid item xs={6}>
              <InfoCard />
            </Grid>

            <Box mx={2} />

            <Grid item xs={6}>
              <InfoCard />
            </Grid>
          </Box>
        </Grid>

        {/* line graph */}
        <Grid item lg={7} xs={12}>
          <LineGraphCard />
        </Grid>

        {/* Row 2 */}
        <Grid item lg={4} xs={12}>
          <PieChartCard />
        </Grid>
        <Grid item lg={4} xs={12}>
          <DataTableCard />
        </Grid>
        <Grid item lg={4} xs={12}>
          <BarChartCard />
        </Grid>

        {/* Row 3 */}

        <Grid item lg={8} xs={12}>
          <DataGridCard />
        </Grid>

        <Grid item lg={4} xs={12}>
          <LineGraph2Card />
        </Grid>

        {/* Row 4 */}

        <Grid item xs={12}  sm={6}    lg={3} >
          <IconInfoCard header="Earnings" icon={EuroOutlined} text={6659} themeColor={theme.palette.primary.main} />
        </Grid>
        <Grid item xs={12}  sm={6}  lg={3} >
          <IconInfoCard header="Products" icon={ShoppingBagOutlined} text={9856} themeColor={theme.palette.secondary.main} />
        </Grid>
        <Grid item xs={12}  sm={6}   lg={3} >
          <IconInfoCard header="Messages" icon={ChatBubbleOutline} text={6659} themeColor={theme.palette.primary.main} />
        </Grid>
        <Grid item xs={12}  sm={6}  lg={3} >
          <IconInfoCard header="New User" icon={PersonOutlined} text={4531} themeColor={theme.palette.primary.main} />
        </Grid>
        
      </Grid>
    </Box>
  );
};

export default AppBody;
